import { UPDATE_AVAILABLE_PARTS_SUCCESS } from './updateAvailablePartsRequest';

export const updateAvailablePartsSuccess = (ids) => ({
  type: UPDATE_AVAILABLE_PARTS_SUCCESS,
  payload: {
    ids,
  }
});
